import { MilestoneType } from '../Milestones';

export enum PayoutEventType {
  milestone = 'milestone',
  materials = 'materials',
  holdback = 'holdback',
  deduction = 'deduction',
  credit = 'credit',
}

export enum PayoutEvent {
  noticeToProceed = 'noticeToProceed',
  noticeToProceedPlus = 'noticeToProceedPlus', // notice to proceed and permit submitted
  estimate = 'estimate',
  invoice = 'invoice',
  installSubmitted = 'installSubmitted',
  installApproved = 'installApproved',
  ptoApproved = 'ptoApproved',
  activationApproved = 'activationApproved',
  siteSurveyApproved = 'siteSurveyApproved',
  siteSurvey = 'siteSurvey',
  standardHoldback = 'standardHoldback',
  domesticContentHoldback = 'domesticContentHoldback',
  other = 'other',
  warranty = 'warranty',
  propertyType = 'propertyType',
  equipment = 'equipment',
  shipping = 'shipping',
  loopFieldApproved = 'loopFieldApproved',
}

export const PayoutEventToEventTypeMap: Record<PayoutEvent, PayoutEventType | null> = {
  [PayoutEvent.noticeToProceed]: PayoutEventType.milestone,
  [PayoutEvent.noticeToProceedPlus]: PayoutEventType.milestone,
  [PayoutEvent.installSubmitted]: PayoutEventType.milestone,
  [PayoutEvent.installApproved]: PayoutEventType.milestone,
  [PayoutEvent.ptoApproved]: PayoutEventType.milestone,
  [PayoutEvent.activationApproved]: PayoutEventType.milestone,
  [PayoutEvent.warranty]: PayoutEventType.deduction,
  [PayoutEvent.equipment]: PayoutEventType.deduction,
  [PayoutEvent.shipping]: PayoutEventType.deduction,
  [PayoutEvent.estimate]: PayoutEventType.materials,
  [PayoutEvent.invoice]: PayoutEventType.materials,
  [PayoutEvent.standardHoldback]: PayoutEventType.holdback,
  [PayoutEvent.domesticContentHoldback]: PayoutEventType.holdback,
  [PayoutEvent.siteSurveyApproved]: PayoutEventType.milestone,
  [PayoutEvent.siteSurvey]: PayoutEventType.credit,
  [PayoutEvent.propertyType]: PayoutEventType.deduction,
  [PayoutEvent.loopFieldApproved]: PayoutEventType.milestone,
  [PayoutEvent.other]: null,
};

export const PayoutEventGroups: { [K in PayoutEvent]?: Array<PayoutEvent> } = {
  [PayoutEvent.noticeToProceed]: [PayoutEvent.noticeToProceed, PayoutEvent.noticeToProceedPlus],
  [PayoutEvent.noticeToProceedPlus]: [PayoutEvent.noticeToProceed, PayoutEvent.noticeToProceedPlus],
  [PayoutEvent.installSubmitted]: [PayoutEvent.installSubmitted, PayoutEvent.installApproved],
  [PayoutEvent.installApproved]: [PayoutEvent.installSubmitted, PayoutEvent.installApproved],
  [PayoutEvent.ptoApproved]: [PayoutEvent.ptoApproved],
  [PayoutEvent.activationApproved]: [PayoutEvent.activationApproved],
  [PayoutEvent.domesticContentHoldback]: [PayoutEvent.domesticContentHoldback],
  [PayoutEvent.standardHoldback]: [PayoutEvent.standardHoldback],
  [PayoutEvent.propertyType]: [PayoutEvent.propertyType],
  [PayoutEvent.equipment]: [PayoutEvent.equipment],
  [PayoutEvent.shipping]: [PayoutEvent.shipping],
  [PayoutEvent.loopFieldApproved]: [PayoutEvent.loopFieldApproved],
};

/**
 * Payout events that can trigger holdback transaction creation.
 * This is the single source of truth for holdback-eligible events.
 */
export const HoldbackPayoutEvents: readonly [
  PayoutEvent.installApproved,
  PayoutEvent.activationApproved,
  PayoutEvent.ptoApproved,
] = [PayoutEvent.installApproved, PayoutEvent.activationApproved, PayoutEvent.ptoApproved] as const;

export type HoldbackPayoutEventType = (typeof HoldbackPayoutEvents)[number];

export const MilestonePayoutEventMap: { [K in MilestoneType]?: Array<PayoutEvent> } = {
  [MilestoneType.noticeToProceed]: [PayoutEvent.noticeToProceed, PayoutEvent.noticeToProceedPlus],
  [MilestoneType.loopField]: [PayoutEvent.loopFieldApproved],
  [MilestoneType.install]: [PayoutEvent.installSubmitted, PayoutEvent.installApproved],
  [MilestoneType.activation]: [PayoutEvent.activationApproved],
};

export const NonPlanPaymentEvents: PayoutEvent[] = [
  PayoutEvent.estimate,
  PayoutEvent.invoice,
  PayoutEvent.warranty,
  PayoutEvent.domesticContentHoldback,
  PayoutEvent.standardHoldback,
  PayoutEvent.propertyType,
  PayoutEvent.equipment,
  PayoutEvent.shipping,
  PayoutEvent.siteSurvey,
  PayoutEvent.other,
];
